import { createScopedReducer } from '@mews/framework';

export const NAME = 'roomingList';

export const reducer = createScopedReducer({}, {});
